<template>
  <div class="app-login">
    <div class="login-bg">
      <img src="@frame/assets/login-header2.png" height="510px" width="845px" />
    </div>
    <div class="login-wrapper">
      <div class="login-body">
        <div style="user-select:none;" class="login-wel">
          <div class="login-wel-title">{{$t('m.i.common.welcom')+'~'}}</div>
          <div class="login-wel-plantform">{{sysName}}</div>
        </div>
        <div class="login-form">
          <HTabsLogin v-model="typeValue"></HTabsLogin>
          <h-form v-show="typeValue=='0'" autocomplete="off" :model="loginForm" ref="loginForm" label-position="left"
            class="card-box login-form">
            <div class="login-form-wrapper">
              <h-form-item prop="username" :class="{'userFocus':userFocusStatus}">
                <h-input name="username" type="text" v-model="loginForm.username" :placeholder="$t('m.i.common.login_username')"
                  @on-focus="handlefocus('user')" @on-blur="handleblur('user')" @on-change="handleChange('user')"
                  @on-enter="handleEnter('user')" ref='username'>
                  <h-icon name="icon-u-a-login-user" size="large" slot="prepend"></h-icon>
                </h-input>
                <div class="verify-tip verify-bottom" v-show='userError'>
                  <div class="verify-tip-arrow"></div>
                  <div class="verify-tip-inner">{{userErrorInfo}}</div>
                </div>
              </h-form-item>
              <h-form-item prop="password" :class="{'pwdFocus':pwdFocusStatus}">
                <h-input type="password" v-model="loginForm.password" autocomplete="new-password" :placeholder="$t('m.i.common.password')"
                  @on-focus="handlefocus('pwd')" @on-blur="handleblur('pwd')" @on-enter="handleEnter('pwd')" ref='password'>
                  <h-icon name="u-a-pwd" slot="prepend"></h-icon>
                </h-input>
                <div class="verify-tip verify-bottom" v-show='passError'>
                  <div class="verify-tip-arrow"></div>
                  <div class="verify-tip-inner">{{passErrorInfo}}</div>
                </div>
              </h-form-item>
              <!-- 验证码 -->
              <h-form-item prop="checkcode" :class="{'checkFocus':checkFocusStatus}" v-if="loginHasValidateCode">
                <h-input @on-enter="handleLogin" @on-focus="handlefocus('check')" @on-blur="handleblur('check')" name="checkcode"
                  type="text" v-model="loginForm.checkcode" autocomplete="on" :placeholder="$t('m.i.common.checkcode')" class="checkInput"
                  style="width: 258px;" ref='check'>
                  <h-icon name="u-a-chk" slot="prepend"></h-icon>
                </h-input>
                <div class="checkcode" style="width:65px;">
                  <span @click="createCode"><img :src="checkCodeUrl" style="width:65px;height: 28px;margin-top: 3px;cursor: pointer;"
                      :title="$t('m.i.common.refreshCode')"></span>
                </div>
                <div class="verify-tip verify-bottom" v-show='codeError'>
                  <div class="verify-tip-arrow"></div>
                  <div class="verify-tip-inner">{{codeErrorInfo}}</div>
                </div>
              </h-form-item>
            </div>
            <div class="form-item-submit">
              <h-form-item style="margin-bottom: 0">
                <h-button type="primary" style="width:100%;" :loading="loading" @click.native.prevent="handleLogin" ref="submit">
                  {{$t('m.i.common.login')}}
                </h-button>
              </h-form-item>
            </div>
          </h-form>
          <!-- 手机验证码登录 -->
          <WebCellPhoneLogin v-show="typeValue=='1'"></WebCellPhoneLogin>
          <div class="to-reg" style="margin-top: 20px;">
            <a class="reg-a" @click="webCommon" style="margin: 10px;">注册账号</a>
            <a class="reg-a" @click="forget" style="margin: 10px;">忘记密码</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCheckCode, getIp } from '@frame/api/login/index'
import { getExtPublicKey, getExtSysConfig } from '@frame/api/common/index'
import { encrypt, encode } from '@frame/utils/Utils'
import Cookies from 'js-cookie'
import cloneDeep from 'clone-deep'
import WebCellPhoneLogin from '@frame/views/loginMode/webCellPhoneLogin'
import HTabsLogin from '@frame/views/loginMode/HTabsLogin'
export default {
  name: 'login',
  components: {
    WebCellPhoneLogin,
    HTabsLogin
  },
  data () {
    return {
      // 公钥
      publicKey: '',
      // 系统名
      sysName: window.LOCAL_CONFIG.SYS_NAME,
      isQuickReg: 'Y',
      isQuickRegUrl: '',
      loginHasValidateCode: true,
      checkCodeUrl: '',
      loginForm: {
        username: '',
        password: '',
        checkcode: '',
        checktoken: ''
      },
      randomCode: '',
      loading: false,
      showDialog: false,
      userError: false,
      userErrorInfo: '',
      codeError: false,
      codeErrorInfo: '',
      passError: false,
      passErrorInfo: '',
      userFocusStatus: false,
      pwdFocusStatus: false,
      checkFocusStatus: false,
      tenantFocusStatus: false,
      animationSpeed: 1,
      tenantData: [],
      tenantListShow: false,
      isShowTenant: false,
      show: true,
      timer: null,
      count: 1,
      typeValue: '0'
    }
  },
  watch: {
    'loginForm.checkcode': {
      handler: function () {
        this.codeError = false
      },
      deep: true
    },
    'loginForm.password': {
      handler: function () {
        this.passError = false
      },
      deep: true
    },
    'loginForm.username': {
      handler: function () {
        this.passError = false
      },
      deep: true
    }
  },
  methods: {
    webCommon () {
      if (this.isQuickRegUrl !== '') {
        window.open(this.isQuickRegUrl)
      } else if (this.isQuickReg === 'N') {
        this.$router.push({ path: '/userReg' })
      } else if (this.isQuickReg === 'Y') {
        this.$router.push({ path: '/regCommon' })
      } else {
        this.toast('error', '请稍后再试')
      }
    },
    forget () {
      this.$router.push({ path: '/forget' })
    },
    // 获取公钥
    getRsaPublickKey () {
      getExtPublicKey({}).then(r => {
        if (r.data.success) {
          this.publicKey = r.data.publicKey
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getDbSysConfig () {
      // 获取系统名称
      getExtSysConfig({ 'code': 'name_of_exchange' }).then(r => {
        if (r.data.success) {
          this.sysName = r.data.value
        }
      }).catch(e => {
        console.log(e)
      })
      // 获取是否快捷注册配置
      getExtSysConfig({ 'code': 'web_quick_reg' }).then(r => {
        if (r.data.success) {
          this.isQuickReg = r.data.value || 'Y'
        }
      }).catch(e => {
        console.log(e)
      })
      // 获取注册地址
      getExtSysConfig({ 'code': 'web_reg_url' }).then(r => {
        if (r.data.success) {
          this.isQuickRegUrl = r.data.value
        }
      }).catch(e => {
        console.log(e)
      })
    },
    toast (type, message, duration = 2) {
      const cfg = { content: message, duration: duration, closable: true }
      switch (type) {
        case 'warning':
          this.$hMessage.warning(cfg)
          break
        case 'success':
          this.$hMessage.success(cfg)
          break
        case 'error':
          this.$hMessage.error(cfg)
          break
        default:
          this.$hMessage.info(cfg)
      }
    },
    isError (r) {
      const d = r.data
      if (!d) {
        this.toast('error', '后台返回的数据格式不正确')
        return false
      }
      if (d.errorNo && d.errorNo !== '0') {
        this.toast('error', d.errorInfo)
        return true
      }
      return false
    },
    /* 登录 */
    handleLogin () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          let pwd = this.loginForm.password
          let param = cloneDeep(this.loginForm)
          param.password = encrypt(pwd, this.publicKey)
          // loginType=sms 手机号登录
          // param.loginType = 'sms'
          this.$store.dispatch('loginOtp', param).then((res) => {
            if (res.errorNo === '0') {
              // 重新登录，获取导航的值，设置false，判断重新获取
              this.$store.commit('SET_DET_MENU', false)
              this.$store.dispatch('getUserImage', '')
              return this.$router.push({ path: '/uc-index' })
            } else if (res.errorNo === '201014') {
              this.refreshCode()
              this.codeErrorInfo = res.errorInfo
              this.loading = false
              this.codeError = true
            } else {
              this.passError = true
              this.passErrorInfo = res.errorInfo
              this.loading = false
              this.refreshCode()
            }
          }).catch(e => {
            console.error(e)
          })
        }
      })
    },
    refreshCode () {
      this.createCode()
    },
    handleEnter (param) {
      switch (param) {
        case 'user':
          this.$refs.password.focus()
          break
        case 'pwd':
          this.$refs.check.focus()
          break
        case 'check':
          this.handleLogin()
          break
      }
    },
    handlefocus (type) {
      if (type === 'user') {
        this.userFocusStatus = true
      }
      if (type === 'pwd') {
        this.pwdFocusStatus = true
      }
      if (type === 'check') {
        this.checkFocusStatus = true
      }
    },
    handleblur (type) {
      if (type === 'user') {
        this.userFocusStatus = false
        this.createCode()
      }
      if (type === 'pwd') {
        this.pwdFocusStatus = false
      }
      if (type === 'check') {
        this.checkFocusStatus = false
      }
    },
    handleChange (type) {

    },
    codeBlur () {

    },
    nameBlur () {

    },
    pwdBlur () {

    },
    /* 生成验证 */
    createCode () {
      getCheckCode({}).then(r => {
        if (r.success) {
          this.checkCodeUrl = r.data
          this.loginForm.checktoken = r.token
        }
      }).catch(e => {
        console.error(e)
      })
    }
  },
  created () {
    // 获取url参数
    let query = this.$route.query

    document.getElementsByTagName('html')[0].className = Cookies.get('theme') ? Cookies.get('theme') : window.LOCAL_CONFIG.THEME
    document.body.className = 'login'
    let isUrlLowercase = window.LOCAL_CONFIG.isUrlLowercase + ''
    if (isUrlLowercase === 'true') {

    }
    getIp({}).then(r => {
      if (r.data.success) {
        Cookies.set('clientIp', r.data.ip)
        window.sessionStorage.setItem('clientIp', r.data.ip)
        this.$localStore.set('clientIp', r.data.ip)
        // 加载秘钥
        this.getRsaPublickKey()
      } else {
        this.$hMessage.error('获取ip地址失败')
      }
    }).catch(e => {
      this.$hMessage.error(e.message)
    })

    // 获取系统名称
    this.getDbSysConfig()
  },
  mounted () {
    if (this.loginHasValidateCode) {
      this.createCode()
    }
    let _self = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key === 38) _self.up()
      if (key === 40) _self.down()
    }
    this.$refs.username.focus()
  },
  destroyed () {
    document.body.className = ''
  },
  beforeDestroy () { // 在组件生命周期结束的时候销毁。
    document.body.removeEventListener('click', this.bodyClick, false)
  },
  beforeCreate () {
    localStorage.setItem('lang', 'zh-CN')
    Cookies.set('lang', 'zh-CN')
    this.$i18n.locale = 'zh-CN'
  }
}
</script>
<style lang="scss" scoped>
.lightblue .app-login .login-wrapper .login-body {
  .login-wel {
    margin-top: 0;
    .login-wel-plantform {
      font-size: 26px;
    }
  }
  .login-form {
    margin-top: 0;
  }
}
</style>